module.exports = __webpack_public_path__ + "img/tencent-h.24508447.png";